import enUS from './en-US';

export default {
  ...enUS,
  'navBar.lang': 'Sprog',
  'layout.user.link.help': 'Hjælp',
  'layout.user.link.privacy': 'Privatliv',
  'layout.user.link.terms': 'Vilkår',
  'component.logout.label': 'Log ud',
  'component.globalHeader.search': 'Søg',
  'component.globalHeader.help': 'Hjælp',
  'component.globalHeader.notification': 'Notifikationer',
  'component.globalHeader.message': 'Beskeder',
  'component.globalHeader.event': 'Begivenheder',
  'component.noticeIcon.clear': 'Ryd',
  'component.noticeIcon.cleared': 'Ryddet',
  'component.noticeIcon.empty': 'Ingen notifikationer',
  'component.noticeIcon.view-more': 'Vis flere',
  'component.refresh': 'Opdater',
  'component.copyAddress': 'Kopiér adresse',
  'component.copySuccess': 'Adressen er kopieret',
  'component.endOfList': 'Slutningen af listen',
  'menu.home': 'Hjem',
  'menu.login': 'Log ind',
  'menu.register': 'Registrer',
  'menu.org': 'Kontrolpanel',
  'menu.org.home': 'Kontrolpanel',
  'menu.org.analysis': 'Analyse',
  'menu.management': 'Administration',
  'menu.management.site-list': 'Websteder',
  'menu.management.players': 'Spillere',
  'menu.management.players.detail': 'Spillerdetaljer',
  'menu.management.game': 'Spil',
  'menu.management.game.category': 'Spilkategorier',
  'menu.management.contents': 'Indhold',
  'menu.settings.finance': 'Økonomi',
  'menu.account': 'Konto',
  'menu.settings': 'Konto og indstillinger',
  'menu.account.center': 'Kontocenter',
  'menu.account.settings': 'Kontoindstillinger',
  'menu.account.logout': 'Log ud',
  'pages.login.accountLogin.tab': 'Medlemsområde',
  'pages.login.failure': 'Login mislykkedes. Prøv igen!',
  'pages.login.username.placeholder': 'Medlems-id / brugernavn',
  'pages.login.username.required': 'Indtast dit brugernavn!',
  'pages.login.password.placeholder': 'Adgangskode',
  'pages.login.password.required': 'Indtast din adgangskode!',
  'pages.login.rememberMe': 'Husk mig',
  'pages.login.forgotPassword': 'Glemt adgangskode?',
  'pages.login.submit': 'Log ind',
  'pages.login.registerAccount': 'Opret konto',
  'pages.login.pleaseVerifyCaptcha': 'Bekræft, at du ikke er en robot.',
  'app.pwa.offline': 'Du er offline nu',
  'app.pwa.serviceworker.updated': 'Nyt indhold er tilgængeligt',
  'app.pwa.serviceworker.updated.ok': 'Opdater',
};
